"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("@searchkit/client");

var _Button = _interopRequireDefault(require("../../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SearchLoadMore = function SearchLoadMore(_ref) {
  var data = _ref.data,
      label = _ref.label,
      className = _ref.className;
  var api = (0, _client.useSearchkit)();

  if (!data) {
    return null;
  }

  var setNextPage = function setNextPage() {
    if (data) {
      api.setPage({
        size: data.results.hits.page.size,
        from: parseInt(data.results.hits.page.size) * (parseInt(data.results.hits.page.pageNumber) + 1)
      });
      api.search();
    }
  };

  var currentPage = data.results.hits.page.pageNumber;
  var lastPage = data.results.hits.page.totalPages;

  if (currentPage + 1 >= lastPage) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: setNextPage
  }, label));
};

var _default = SearchLoadMore;
exports.default = _default;